import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { getCurrentDate, isLoggedIn } from '../helper/utils';
import { protectedRoutes, publicRoutes } from '../router';
import "./NavBar.css";


const Logo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 698.5822 200"
    {...props}
  >
    <defs>
      <radialGradient
        id="radial-gradient"
        cx={19635.913}
        cy={22003.962}
        r={149.133}
        fx={19635.913}
        fy={22003.962}
        gradientTransform="matrix(.5288 .04607 -.04632 .52878 -9254.66 -12338.388)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={0.264} stopColor="#fbfdfe" />
        <stop offset={0.476} stopColor="#f1f9fa" />
        <stop offset={0.67} stopColor="#e0f1f5" />
        <stop offset={0.852} stopColor="#c9e7ee" />
        <stop offset={1} stopColor="#b0dce7" />
      </radialGradient>
      <radialGradient
        xlinkHref="#radial-gradient"
        id="radial-gradient-2"
        cx={19614.061}
        cy={21753.59}
        r={216.401}
        fx={19614.061}
        fy={21753.59}
      />
      <radialGradient
        id="radial-gradient-3"
        cx={67936.48}
        cy={39518.092}
        r={237.002}
        fx={67936.48}
        fy={39518.092}
        gradientTransform="matrix(-.5288 -.04607 .04632 -.52878 34124.628 24040.024)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#86ccd2" />
        <stop offset={1} stopColor="#2a376c" />
      </radialGradient>
      <radialGradient
        xlinkHref="#radial-gradient-3"
        id="radial-gradient-4"
        cx={19734.657}
        cy={21904.479}
        r={236.902}
        fx={19734.657}
        fy={21904.479}
        gradientTransform="matrix(.5288 .04607 -.04632 .52878 -9254.66 -12338.388)"
      />
      <radialGradient
        id="radial-gradient-5"
        cx={82.769}
        cy={72.063}
        r={61.11}
        fx={82.769}
        fy={72.063}
        gradientTransform="translate(-86.456 -173.385) scale(2.7329)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#eaf5f5" />
        <stop offset={0.5} stopColor="#00b0b2" />
        <stop offset={0.75} stopColor="#2d779e" />
        <stop offset={1} stopColor="#063266" />
      </radialGradient>
      <style>
        {".cls-5{fill:var(--sp-light-blue)}.cls-8{fill:#fff}.cls-9{fill:#9aa6a9}"}
      </style>
    </defs>
    <path
      d="M192.756 104.546c-4.615 52.63-51.144 91.57-103.925 86.964-52.777-4.606-91.823-51.008-87.204-103.64C6.247 35.234 52.776-3.7 105.552.906c52.78 4.602 91.822 51.004 87.204 103.64Z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M57.836 183.472c9.554 4.288 19.974 7.073 31 8.033 52.776 4.607 99.3-34.328 103.915-86.959 1.283-14.591-.795-28.699-5.586-41.573-2.234 20.61-12.557 66.94-61.619 78.18-57.723 13.214-57.525 29.13-67.71 42.319Z"
      style={{
        fill: "url(#radial-gradient)",
      }}
    />
    <path
      d="M105.556.91C52.78-3.696 6.251 35.238 1.632 87.87c-1.326 15.131.954 29.747 6.137 43.004 4.636-17.062 20.133-55.119 67.222-63.065 61.127-10.316 76.708-28.413 81.2-45.78.093-.357.181-.71.27-1.054C142.3 9.858 124.844 2.592 105.556.91Z"
      style={{
        fill: "url(#radial-gradient-2)",
      }}
    />
    <path
      d="M17.995 42.475C36.218 14.703 71.72-3.944 111.702 1.611 50.138 1.51 7.18 55.66 35.878 99.183c14.757 22.386 45.789 38.041 55.582 46.608 12.128 10.61 13.28 20.686 12.187 27.15-1.233 7.296-7.257 12.233-10.925 13.89-9.68 4.368-20.625 1.678-20.894 1.611-58.426-15.24-93.572-85.412-53.833-145.968Z"
      style={{
        fill: "url(#radial-gradient-3)",
      }}
    />
    <path
      d="M176.552 149.94c-18.223 27.768-53.79 46.902-93.707 40.865 61.568.097 104.522-54.05 75.828-97.574-14.76-22.388-45.793-38.04-55.586-46.611C90.96 36.015 89.811 25.934 90.905 19.47c1.228-7.292 7.256-12.234 10.924-13.891 9.68-4.367 20.503-1.443 20.773-1.372 58.425 15.237 93.69 85.174 53.95 145.734Z"
      style={{
        fill: "url(#radial-gradient-4)",
      }}
    />
    <path
      d="M17.663 42.635C35.886 14.867 71.79-4.43 111.703 1.61c-69.65-.151-108.233 56-77.697 102.658 14.685 22.435 50.172 37.73 58.762 44.824 9.676 7.987 11.939 17.38 10.879 23.85-1.044 6.376-5.641 11.893-11.413 14.23-10.08 4.086-19.56 1.497-20.747 1.178-58.207-15.488-93.488-85.274-53.824-145.716Zm159.225 107.142c-18.223 27.771-54.127 47.065-94.043 41.028 69.649.147 108.237-56.004 77.696-102.662-14.685-22.435-50.168-37.731-58.762-44.82-9.675-7.992-11.934-17.385-10.874-23.854 1.043-6.376 5.641-11.893 11.408-14.23 10.083-4.086 19.56-1.493 20.751-1.178 58.207 15.492 93.484 85.278 53.824 145.716Z"
      style={{
        fill: "url(#radial-gradient-5)",
      }}
    />
    <path
      d="M342.663 139.558c1.998 1.166 8.42 4.203 16.12 4.203 9.164 0 17.268-3.355 17.268-13.756v-3.674c-1.262 1.786-6.75 8.512-17.597 8.503-15.791 0-26.318-11.863-26.318-28.674 0-16.905 10.95-28.882 26.537-28.882 10.317.004 16.221 6.2 17.9 8.721v-7.345h10.846v47.572c0 20.589-12.525 27.406-28.519 27.406-7.382 0-15.076-2.412-19.918-5.257l3.68-8.818Zm17.268-52.09c-9.469 0-16.322 7.567-16.322 18.592 0 11.238 7.057 18.593 16.436 18.593 9.892 0 16.321-7.77 16.321-18.593 0-11.239-6.955-18.592-16.435-18.592ZM420.494 88.835c-12.006 0-15.484 9.133-15.484 21.009v23.794h-11.472V78.654h11.256v8.604c2.112-5.466 7.909-9.976 15.7-9.976v11.554ZM448.399 77.282c16.964 0 29.174 12.287 29.174 28.778s-12.426 28.783-29.174 28.783c-16.846 0-29.058-12.087-29.058-28.683s12.527-28.878 29.058-28.878Zm0 47.37c10.221 0 17.699-7.878 17.699-18.592s-7.478-18.592-17.7-18.592c-10.32 0-17.48 7.978-17.48 18.692 0 10.824 7.269 18.493 17.48 18.493ZM482.14 111.631V78.654h11.368v33.921c0 7.56 4.741 11.969 11.07 11.969 7.255 0 12-5.248 12-12.812V78.654h11.484v54.984H516.79v-7.307c-2.422 4.409-8.108 8.512-15.483 8.512-14.218 0-19.167-11.248-19.167-23.212ZM534.174 78.654h10.832v7.24c1.493-1.993 7.06-8.612 17.703-8.612 15.701 0 26.86 11.977 26.86 28.673 0 17.011-10.435 28.888-26.124 28.888-10.432 0-16.332-6.306-17.798-8.621v26.886h-11.473V78.654Zm27.477 45.999c9.584 0 16.332-7.67 16.332-18.698 0-11.234-7.064-18.487-16.435-18.487-10.106 0-16.333 8.406-16.333 18.487 0 11.868 7.272 18.698 16.436 18.698Z"
      className="cls-9"
    />
    <path
      d="M231.528 113.796c2.244 5.257 7.116 10.4 16.244 10.4 7.469 0 12.918-3.676 12.918-9.868 0-15.547-37.828-12.077-37.828-35.708 0-11.449 9.608-19.856 24.91-19.856 15.773 0 22.533 9.872 24.552 15.019l-10.922 4.309c-1.902-3.57-5.686-8.613-13.88-8.613-7.343 0-11.9 3.985-11.9 9.036 0 14.49 37.989 11.868 37.989 34.97 0 12.292-10.066 21.53-26.438 21.53-16.955 0-24.31-10.076-26.797-16.596l11.152-4.623ZM280.279 60.136h24.848c13.905 0 23.587 10.417 23.587 23.652 0 13.022-10.107 23.93-23.486 23.93H291.53v25.929H280.28v-73.51Zm23.468 37.144c7.699 0 12.967-6.142 12.967-13.492 0-7.257-5.268-13.252-12.85-13.252h-12.333V97.28h12.216Z"
      className="cls-8"
    />
    <path
      d="M220.62 170.086h11.441v3.297h-7.77v6.431h6.745v3.264h-6.745v6.793h8.1v3.298h-11.77v-23.083ZM259.742 193.169h-3.57v-10.322c0-2.67-1.158-4.088-3.307-4.088-2.017 0-3.505 1.484-3.505 4.121v10.289h-3.604v-10.65c0-2.343-1.257-3.76-3.307-3.76-1.95 0-3.472 1.582-3.472 4.056v10.354h-3.604v-17.214h3.538v2.243c.628-1.319 2.315-2.671 4.663-2.671 2.413 0 4.133 1.121 4.96 2.869 1.024-1.814 2.942-2.87 5.323-2.87 3.902 0 5.885 2.672 5.885 6.398v11.245ZM263.36 175.956h3.406v2.275c.463-.627 2.215-2.704 5.555-2.704 4.927 0 8.432 3.76 8.432 9.002 0 5.342-3.274 9.068-8.2 9.068-3.274 0-5.125-1.978-5.589-2.704v8.442h-3.604v-23.38Zm8.63 14.443c3.01 0 5.126-2.408 5.126-5.87 0-3.528-2.216-5.803-5.159-5.803-3.174 0-5.125 2.638-5.125 5.803 0 3.727 2.282 5.87 5.159 5.87ZM291.583 175.527c5.324 0 9.16 3.858 9.16 9.035s-3.902 9.035-9.16 9.035c-5.29 0-9.126-3.792-9.126-9.002s3.935-9.068 9.126-9.068Zm0 14.872c3.208 0 5.555-2.473 5.555-5.837s-2.347-5.836-5.555-5.836c-3.24 0-5.489 2.505-5.489 5.869 0 3.396 2.282 5.804 5.489 5.804ZM314.43 180.836l-3.902 12.333h-3.968l-5.489-17.214h3.902l3.77 13.19s.032-.065 3.967-13.19h3.44c3.901 13.125 3.934 13.19 3.934 13.19l3.803-13.19h3.901L322.3 193.17h-4l-3.87-12.333ZM336.548 175.527c5.224 0 8.3 3.594 8.3 9.002 0 .297 0 .594-.034.89H331.82c.065 3.067 2.281 5.046 5.356 5.046 2.613 0 4.1-1.451 4.762-2.407l2.38 1.78c-.826 1.418-3.108 3.76-7.208 3.76-5.39 0-8.96-3.76-8.96-8.97 0-5.342 3.67-9.101 8.398-9.101Zm4.629 7.42c-.132-2.836-2.116-4.419-4.596-4.419s-4.398 1.715-4.629 4.419h9.225ZM355.953 179.155c-3.77 0-4.86 2.868-4.86 6.594v7.42h-3.605v-17.214h3.538v2.705c.66-1.715 2.48-3.133 4.927-3.133v3.628ZM359.665 169.46c1.256 0 2.248.989 2.248 2.242s-.992 2.242-2.248 2.242-2.25-.99-2.25-2.242.993-2.242 2.25-2.242Zm-1.786 6.495h3.604v17.214h-3.604v-17.214ZM379.556 182.815v10.354h-3.571v-10.65c0-2.376-1.488-3.76-3.473-3.76-2.28 0-3.769 1.682-3.769 4.023v10.387h-3.604v-17.214h3.538v2.243c.76-1.352 2.546-2.671 4.86-2.671 4.464 0 6.019 3.528 6.019 7.288ZM385.41 195.081c.628.363 2.646 1.32 5.06 1.32 2.876 0 5.422-1.056 5.422-4.32v-1.155c-.397.561-2.116 2.671-5.522 2.671-4.96 0-8.266-3.726-8.266-9.002 0-5.309 3.439-9.068 8.332-9.068 3.24 0 5.092 1.946 5.621 2.737v-2.309h3.406v14.938c0 6.464-3.935 8.607-8.96 8.607-2.315 0-4.729-.759-6.25-1.649l1.157-2.77Zm5.423-16.355c-2.976 0-5.125 2.374-5.125 5.836 0 3.529 2.215 5.837 5.158 5.837 3.109 0 5.125-2.44 5.125-5.837 0-3.528-2.182-5.836-5.158-5.836ZM411.96 172.361h3.57v3.595h3.506v2.967h-3.505v8.013c0 2.671 1.025 3.265 2.943 3.265.297 0 .694-.033.694-.033v3.1s-.628.132-1.752.132c-4.2 0-5.456-2.803-5.456-7.024v-7.453h-1.918v-2.967h1.918v-3.595ZM436.03 182.815v10.354h-3.57v-10.65c0-2.376-1.489-3.76-3.472-3.76-2.282 0-3.803 1.682-3.803 4.023v10.387h-3.604v-23.841h3.604v8.87c.76-1.352 2.512-2.671 4.827-2.671 4.464 0 6.018 3.528 6.018 7.288ZM446.993 175.527c5.224 0 8.3 3.594 8.3 9.002 0 .297 0 .594-.034.89h-12.994c.066 3.067 2.281 5.046 5.356 5.046 2.613 0 4.1-1.451 4.762-2.407l2.38 1.78c-.826 1.418-3.108 3.76-7.208 3.76-5.39 0-8.96-3.76-8.96-8.97 0-5.342 3.67-9.101 8.398-9.101Zm4.63 7.42c-.133-2.836-2.117-4.419-4.597-4.419s-4.398 1.715-4.629 4.419h9.225ZM466.896 170.086h11.407v3.297h-7.737v6.695h6.779v3.264h-6.779v9.827h-3.67v-23.083ZM480.213 186.31v-10.354h3.571v10.65c0 2.375 1.488 3.76 3.472 3.76 2.282 0 3.77-1.649 3.77-4.023v-10.387h3.604v17.213h-3.539v-2.243c-.76 1.385-2.546 2.671-4.86 2.671-4.464 0-6.018-3.528-6.018-7.287ZM498.625 172.361h3.572v3.595h3.504v2.967h-3.504v8.013c0 2.671 1.025 3.265 2.942 3.265.298 0 .695-.033.695-.033v3.1s-.629.132-1.753.132c-4.2 0-5.456-2.803-5.456-7.024v-7.453h-1.917v-2.967h1.917v-3.595ZM507.79 186.31v-10.354h3.572v10.65c0 2.375 1.487 3.76 3.471 3.76 2.282 0 3.77-1.649 3.77-4.023v-10.387h3.604v17.213h-3.538v-2.243c-.76 1.385-2.546 2.671-4.861 2.671-4.464 0-6.018-3.528-6.018-7.287ZM534.285 179.155c-3.77 0-4.861 2.868-4.861 6.594v7.42h-3.604v-17.214h3.538v2.705c.66-1.715 2.48-3.133 4.927-3.133v3.628ZM543.479 175.527c5.224 0 8.3 3.594 8.3 9.002 0 .297 0 .594-.034.89H538.75c.066 3.067 2.282 5.046 5.357 5.046 2.613 0 4.1-1.451 4.762-2.407l2.38 1.78c-.826 1.418-3.108 3.76-7.208 3.76-5.39 0-8.96-3.76-8.96-8.97 0-5.342 3.67-9.101 8.398-9.101Zm4.629 7.42c-.132-2.836-2.116-4.419-4.596-4.419s-4.398 1.715-4.629 4.419h9.225ZM571.053 175.527c5.324 0 9.16 3.858 9.16 9.035s-3.902 9.035-9.16 9.035c-5.29 0-9.126-3.792-9.126-9.002s3.935-9.068 9.126-9.068Zm0 14.872c3.208 0 5.555-2.473 5.555-5.837s-2.347-5.836-5.555-5.836c-3.24 0-5.489 2.505-5.489 5.869 0 3.396 2.282 5.804 5.49 5.804ZM583.239 178.923h-1.885v-2.967h1.885v-.758c0-4.386 2.81-5.837 5.885-5.837.695 0 1.29.066 1.29.066v3.066s-.463-.065-.86-.065c-1.753 0-2.711.89-2.711 2.835v.693h3.339v2.967h-3.34v14.246h-3.603v-14.246ZM601.522 170.086h11.44v3.297h-7.77v6.431h6.746v3.264h-6.745v6.793h8.1v3.298h-11.771v-23.083ZM630.691 182.815v10.354h-3.57v-10.65c0-2.376-1.489-3.76-3.473-3.76-2.281 0-3.77 1.682-3.77 4.023v10.387h-3.603v-17.214h3.537v2.243c.761-1.352 2.546-2.671 4.861-2.671 4.464 0 6.018 3.528 6.018 7.288ZM641.654 175.527c5.224 0 8.3 3.594 8.3 9.002 0 .297 0 .594-.034.89h-12.995c.066 3.067 2.282 5.046 5.357 5.046 2.612 0 4.1-1.451 4.762-2.407l2.38 1.78c-.826 1.418-3.108 3.76-7.208 3.76-5.39 0-8.96-3.76-8.96-8.97 0-5.342 3.67-9.101 8.398-9.101Zm4.629 7.42c-.132-2.836-2.116-4.419-4.596-4.419s-4.398 1.715-4.629 4.419h9.225ZM661.059 179.155c-3.77 0-4.86 2.868-4.86 6.594v7.42h-3.605v-17.214h3.538v2.705c.66-1.715 2.48-3.133 4.927-3.133v3.628ZM665.18 195.081c.63.363 2.647 1.32 5.06 1.32 2.877 0 5.423-1.056 5.423-4.32v-1.155c-.397.561-2.116 2.671-5.522 2.671-4.96 0-8.266-3.726-8.266-9.002 0-5.309 3.438-9.068 8.332-9.068 3.24 0 5.092 1.946 5.62 2.737v-2.309h3.407v14.938c0 6.464-3.935 8.607-8.961 8.607-2.315 0-4.728-.759-6.25-1.649l1.158-2.77Zm5.424-16.355c-2.976 0-5.125 2.374-5.125 5.836 0 3.529 2.215 5.837 5.158 5.837 3.108 0 5.125-2.44 5.125-5.837 0-3.528-2.182-5.836-5.158-5.836ZM685.292 199.071l2.447-6.199-6.845-16.917h3.869l4.662 12.531 4.597-12.53h3.77l-9.028 23.115h-3.472Z"
      className="cls-5"
    />
  </svg>
);

const pathToLabel = (str) => !(str && typeof str === "string" && str.length > 1) ? "" :
  str
    .slice(1)
    .split("/")[0]
    .split("-")
    .reduce((prev, curr) => `${prev} ${curr[0].toUpperCase()}${curr.slice(1)}`, "");

function Sidebar() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {}, [isLoggedIn()]);

  return (
    <>
      <Button variant="outline-light" onClick={handleShow} className='h-100 p-1 d-flex align-items-center justify-content-center'>
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-list logo" viewBox="0 0 16 16">
          <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
        </svg>
      </Button>

      <Offcanvas show={show} onHide={handleClose} placement='end'>
        <Offcanvas.Header closeVariant="white" closeButton></Offcanvas.Header>
        <Offcanvas.Body>
          <LinkContainer to="/" onClick={handleClose}>
            <a className='text-light'><p>{isLoggedIn() ? "Home" : "Login"}</p></a>
          </LinkContainer>
          {
            [...publicRoutes, ...(isLoggedIn() ? protectedRoutes : [])].map((route, idx) => {
              return (
                <LinkContainer to={route.path} key={idx} onClick={handleClose}>
                  <a className='text-light'>
                    <p>{pathToLabel(route.path)}</p>
                  </a>
                </LinkContainer>
              );
            })
          }
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

function NavBar({ navbarDate }) {
  const location = useLocation();
  const [refresh, setRefresh] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => setRefresh((r) => !r), 60 * 1000); // re-render every minute
    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [refresh]);

  const getNavbarLabel = () => {
    if (location.pathname === "/") { return ""; }
    const header = pathToLabel(location.pathname);
    if (location.pathname === "/new-submission") { return header; }
    return `${header} (${location.pathname === "/facility-data" ? navbarDate : getCurrentDate()})`
  }

  return (
    <Navbar id="navbar" fixed='top' className='shadow'>
      <h2 className='position-absolute top-50 start-50 translate-middle text-light'>
        {getNavbarLabel()}
      </h2>
      <LinkContainer to="/">
        <Logo className="logo"/>
      </LinkContainer>
      <Sidebar />
    </Navbar>
  );
}

export default NavBar;